"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _scrolling = _interopRequireDefault(require("../../navigation/scrolling"));

var _crossGrey = _interopRequireDefault(require("../../../assets/img/icons/cross-grey.svg"));

var _helpers = require("../scrolling/helpers");

var _styled = require("./styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FilterTags = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterTags, _React$Component);

  var _super = _createSuper(FilterTags);

  function FilterTags(props) {
    var _this;

    _classCallCheck(this, FilterTags);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isCarousel: true
    });

    _defineProperty(_assertThisInitialized(_this), "checkCarousel", function () {
      _this.setState({
        isCarousel: window && window.innerWidth < 1080
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeFilter", function (event, tag) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          selected = _this$props.selected,
          onChange = _this$props.onChange;

      var active = _this.isActive(tag);

      (0, _helpers.moveButtons)(event, _this.scrollingRef.current);

      if (multiple) {
        var currentFilters = Array.isArray(selected) ? selected : [];
        onChange(active ? selected.filter(function (filter) {
          return filter !== tag;
        }) : currentFilters.concat(tag));
      } else {
        onChange(active ? null : tag);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isActive", function (tag) {
      var selected = _this.props.selected;
      var selectedArray = Array.isArray(selected) ? selected : [selected];
      return selectedArray.indexOf(tag) !== -1;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTags", function () {
      var options = _this.props.options;
      return options.map(function (tag, index) {
        var active = _this.isActive(tag);

        return /*#__PURE__*/_react["default"].createElement(_styled.Tag, {
          key: index,
          active: active,
          onClick: function onClick(event) {
            return _this.changeFilter(event, tag);
          }
        }, tag.title || tag.name, /*#__PURE__*/_react["default"].createElement(_styled.Cross, {
          src: _crossGrey["default"],
          active: active
        }));
      });
    });

    _this.scrollingRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(FilterTags, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkCarousel();
      window.addEventListener('resize', this.checkCarousel);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.checkCarousel);
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var isCarousel = this.state.isCarousel;
      var Wrapper = isCarousel ? _scrolling["default"] : _styled.Container;
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        className: className,
        ref: isCarousel ? this.scrollingRef : null
      }, this.renderTags());
    }
  }]);

  return FilterTags;
}(_react["default"].Component);

FilterTags.defaultProps = {
  options: [],
  selected: [],
  multiple: false,
  onChange: function onChange() {}
};
var _default = FilterTags;
exports["default"] = _default;